import { updateBoost, updateBoostGYDB } from '../graphql/mutations';
import { makeApiAction } from './actions';
import { audienceTargetingDetails } from '../graphql/queries';
import { devLog } from '../utils';
import store from '../store';

const BOOST_TYPE_GYDB = 'growyourdatabase';

/**
 * Fetch audience targeting
 *
 */
export const fetchAudienceTargetingAction = () => async (dispatch) => {
  const action = 'FETCH_AUDIENCE_TARGETING';

  await dispatch(
    makeApiAction(action, audienceTargetingDetails, {}, null, 'audienceTargetingDetails', true),
  );
};

export const updateAudienceTargetingAction =
  (boostType, enabled, dineIn = null, takeaway = null) =>
  async (dispatch) => {
    const action = 'UPDATE_AUDIENCE_TARGETING';
    const variables = {
      boostType,
      enabled,
      ...(enabled && dineIn !== null && { dineIn }),
      ...(enabled && takeaway !== null && { takeaway }),
    };

    const restId = store?.getState()?.restaurantActive?.restaurant?.objectId;
    const isGYDB = boostType === BOOST_TYPE_GYDB;
    const mutation = isGYDB ? updateBoostGYDB : updateBoost;
    const mutationLabel = isGYDB ? 'updateBoostGYDB' : 'updateBoost';

    devLog('info', `${mutationLabel} ${enabled ? 'enable' : 'disable'}`, {
      boostType,
      enabled,
      dineIn: enabled && dineIn !== null ? dineIn : '(omitted when disabling)',
      takeaway: enabled && takeaway !== null ? takeaway : '(omitted when disabling)',
      restId,
      fullVariablesToApi: { ...variables, restId },
    });

    await dispatch(
      makeApiAction(
        action,
        mutation,
        variables,
        null,
        mutationLabel,
        true,
        null,
        null,
        {},
        false,
        null,
        false,
        () => {
          // Auto-refetch audience targeting data after successful mutation
          dispatch(fetchAudienceTargetingAction());
        },
      ),
    );
  };
